import React, { Component } from "react";
import PropTypes from "prop-types";
import Paper from "@mui/material/Paper";
import { grey } from "@mui/material/colors";
import { Box } from "@mui/material";

const s:any = {
  content: {
    padding: "5px 10px",
    ml: 1, //60
    height: 50, //80
  },
  number: {
    display: "block",
    mt: 1,//10
    fontWeight: 'typography.fontWeightMedium',
    fontSize: 18,
    color: grey["800"],
    textAlign: "center",
  },
  text: {
    display: "block",
    fontSize: 18,
    fontWeight: 'typography.fontWeightLight',
    color: grey["800"],
    textAlign: "center",
  },
  iconSpan: {
    float: "left",
    height: 60, //90
    width: 60, //90
    textAlign: "center",
    //backgroundColor: theme.color
  },
  icon: {
    height: 50,
    width: 50,
    //marginTop: 5, //20
    fill: "white",
    maxWidth: "100%",
  },
};

class InfoBox extends Component<any, any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props: any) {
    super(props);
    this.state = {
      test: null,
    };
  }

  render() {
    const { color, title, value, Icon, classes } = this.props;
    const extras = {
      span: {
        backgroundColor: color,
        justifyContent: "center",
        display: "flex",
        alignItems: "center",
      },
    };
    return (
      <Paper
        sx={{
          margin: 2,

          width: "100%",
        }}
      >
        {/* <Box component='span' className={classNames(classes.iconSpan,extras.span)} style={extras.span}> */}
        <Box component='span' sx={{...s.iconSpan,...extras.span}} style={extras.span}>
          <Icon htmlColor={"white"} sx={{...s.icon}} />
        </Box>

        <Box sx={{...s.content}}>
          <Box component='span' sx={{...s.text}}>{title}</Box>
          <Box component='span' sx={{...s.number}}>{value}</Box>
        </Box>
      </Paper>
    );
  }
}

InfoBox.propTypes = {
  Icon: PropTypes.any, // eslint-disable-line
  color: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.any,
};

// export default InfoBox;
export default InfoBox;
